import { apiClient } from "@/config/api";
import {
  SyncStatus,
  SyncHistoryResponse,
  SyncLog,
} from "@/types/kkmovie";
import { ApiResponse } from "@/types/status";

const SYNC_ENDPOINTS = {
  STATUS: "/kkphim-sync/status",
  HISTORY: "/kkphim-sync/history",
  TRIGGER: "/kkphim-sync/trigger",
  SYNC_SINGLE: (slug: string) => `/kkphim-sync/sync/${slug}`,
} as const;

export const kkphimSyncService = {
  // Lấy trạng thái sync hiện tại
  getSyncStatus: async (): Promise<ApiResponse<SyncStatus>> => {
    return await apiClient.get(SYNC_ENDPOINTS.STATUS);
  },

  // Lấy lịch sử sync
  getSyncHistory: async (
    page: number = 1,
    limit: number = 20
  ): Promise<ApiResponse<SyncHistoryResponse>> => {
    return await apiClient.get(SYNC_ENDPOINTS.HISTORY, { page, limit } as any);
  },

  // Trigger sync thủ công (tất cả phim ONGOING/UPCOMING)
  triggerSync: async (): Promise<ApiResponse<SyncLog>> => {
    return await apiClient.post(SYNC_ENDPOINTS.TRIGGER);
  },

  // Sync 1 phim cụ thể theo slug
  syncSingleMovie: async (slug: string): Promise<ApiResponse<SyncLog>> => {
    return await apiClient.post(SYNC_ENDPOINTS.SYNC_SINGLE(slug));
  },
};
